import {ChangeDetectionStrategy, Component, computed, inject, signal} from "@angular/core";
import {MatBadgeModule} from "@angular/material/badge";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {MatIcon} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {Router} from "@angular/router";
import {MealPlanModelToApproveDTO} from "@menu-api";
import {TranslatePipe} from "@ngx-translate/core";
import moment from "moment";
import {MEAL_PLAN_MODELS, ROUGH_PLANNING} from "../../../app.routes";
import {CREATE as MEAL_PLAN_MODEL_CREATE} from "../../../pages/meal-plan-model/meal-plan-model.routes";
import {CREATE as ROUGH_PLAN_CREATE} from "../../../pages/rough-planning/rough-planning.routes";
import {MealPlanModelApiClient} from "../../../services/api/meal-plan-model-api-client";
import {CREATION_TYPE} from "../../../services/meal-plan-model-creation-service";

@Component({
    selector: "app-notifications",
    imports: [
        MatIcon,
        MatIconButton,
        MatBadgeModule,
        MatMenuModule,
        MatCardModule,
        MatButton,
        MatProgressSpinner,
        TranslatePipe,

    ],
    templateUrl: "./notifications.component.html",
    styleUrl: "./notifications.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent {
    protected readonly models = signal<MealPlanModelToApproveDTO[]>([]);

    protected readonly mealPlanModelService = inject(MealPlanModelApiClient);
    private readonly router = inject(Router);

    private readonly isApprovalNeeded = this.mealPlanModelService.isApprovalNeeded();
    protected readonly notificationPresent = computed(() => {
        return this.isApprovalNeeded();// There might be more notification types in the future
    });
    protected readonly loadingModelId = signal<string | null>(null);

    protected async loadData(): Promise<void> {
        const models = await this.mealPlanModelService.findMealPlanModelsToApprove();
        models.forEach((model) => {
            model.modifiedAt = moment(model.modifiedAt).fromNow();
        });
        this.models.set(models);
    }

    protected async jumpToModel(model: MealPlanModelToApproveDTO): Promise<void> {
        this.loadingModelId.set(model.id);
        try {
            // Rough plan models share the same table as meal plan models, so we need the model
            // detail to decide which creation dialog to open.
            const {rough} = await this.mealPlanModelService.findMealPlanModelListDTO(model.id);
            const baseRoute = rough ? ROUGH_PLANNING : MEAL_PLAN_MODELS;
            const createRoute = rough ? ROUGH_PLAN_CREATE : MEAL_PLAN_MODEL_CREATE;
            await this.router.navigate([baseRoute, createRoute], {
                queryParams: {modelId: model.id, mode: CREATION_TYPE.EDIT.name},
                queryParamsHandling: "merge",
            });
        } catch {
            // Model might have been removed in the meantime; keep the menu usable for retry.
        } finally {
            this.loadingModelId.set(null);
        }
    }
}
